/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import get from 'lodash/get';
import noop from 'lodash/noop';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { Modal } from 'carbon-addons-iot-react';
import { useField } from 'formik';

import { ToggleSmallFormik } from 'Common';

const messages = defineMessages({
  validationOptions: 'Validation options for property {propName}',
  forbidNull: 'Forbid null',
  allowNull: 'Allow null',
});

const propTypes = {
  /* Path to a schema property in Formik model e.g. 'schema.content.properties[0]' */
  fieldId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  readOnly: PropTypes.bool,
};

const defaultProps = {
  open: false,
  readOnly: false,
  onRequestClose: noop,
};

const ValidationOptionsModal = ({
  fieldId,

  open,
  readOnly,
  onRequestClose,

  intl: { formatMessage },
}) => {
  const [field] = useField(fieldId);

  return (
    <Modal
      className="validation-options-modal"
      modalHeading={formatMessage(messages.validationOptions, {
        propName: get(field, 'value.name'),
      })}
      modalAriaLabel="Validation Options Modal"
      size="sm"
      passiveModal
      hasScrollingContent={false}
      onRequestClose={onRequestClose}
      open={open}>
      <div className="validation-options-modal--inner">
        <ToggleSmallFormik
          id={`${fieldId}.allowNull`}
          aria-label="Allow null toggle"
          disabled={readOnly}
          labelA={formatMessage(messages.forbidNull)}
          labelB={formatMessage(messages.allowNull)}
        />
      </div>
    </Modal>
  );
};

ValidationOptionsModal.propTypes = propTypes;
ValidationOptionsModal.defaultProps = defaultProps;
export default injectIntl(ValidationOptionsModal);
